// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div[data-v-60804842]{text-align:right}`, "",{"version":3,"sources":["webpack://./src/shared/components/ncTable/partials/TableCellNumber.vue"],"names":[],"mappings":"AAEA,qBACC,gBAAA","sourcesContent":["\n\ndiv {\n\ttext-align: right;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
